import React, {Component} from 'react';
import {inject, observer} from "mobx-react/index";
import axios from "axios/index";

@inject("store")
@observer
export default class ModalShareCalculation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            emailInput: '',
            emailSend: false,
            submitted: false
        };
    }

    handleChange = (event) => {
        this.setState({emailInput: event.target.value});
    }

    closeModal = () => {
        this.props.closeModal();
    };

    componentWillMount = () => {
        document.body.classList.add("noScroll");
        document.documentElement.classList.add('noScroll');

        $("html, body").animate({scrollTop: 0}, "slow");
    }

    componentWillUnmount = () => {
        document.body.classList.remove('noScroll');
        document.documentElement.classList.remove('noScroll');
    };

    shareSend = () => {
        this.setState({submitted: true});

        const {questionCount, result} = this.props.store;
        const {printDate, resultInfo, resultDate, resultDate2, date, date2, ignoreHolidays} = result;
        const questions = result.questions.slice();

        const validateEmail = function (email) {
            var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            return re.test(email);
        }

        const mail = this.state.emailInput;
        const mailAddresses = mail.split(',');
        let valid = true;
        for (let i = 0; i < mailAddresses.length; i++) {
            const address = mailAddresses[i];
            if (!validateEmail(address.trim())) {
                valid = false;
                break;
            }
        }
        if (valid) {
            const answers = [];
            for (let i = 0; i < questionCount; i++) {
                const q = questions[i];
                const nextQ = (i + 1) < questionCount ? questions[i + 1] : undefined;
                const a = {
                    "question": q.question,
                    "answer": nextQ ? nextQ.answer : printDate
                };
                answers.push(a);
            }

            var data = {
                mail: mail,
                resultInfo: resultInfo,
                date: date,
                resultDate: resultDate,
                date2: date2,
                resultDate2: resultDate2,
                answers: answers,
                ignoreHolidays: ignoreHolidays
            };

            axios.post('/ajax/share', data)
                .then((response) => {

                    this.setState({
                        emailSend: true
                    });

                    setTimeout(() => {
                        this.closeModal();
                    }, 7000);

                })
                .catch((error) => {
                    console.log(error);
                    alert('Det lykkedes ikke at dele resultatet');
                });

            this.setState({submitted: false});
        }
    };

    render() {

        const {
            emailSend,
            emailInput,
            submitted,
        } = this.state;
        
        const classNames = ['input'];
        if(emailInput !== '') classNames.push('hasValue');
        if(submitted && !emailSend) classNames.push('error');

        return (
            <div className="share-popup">
                <div className="inner">
                    <span className="close" onClick={this.closeModal}></span>
                    <div className="wrap">
                        <h3>Del din beregning</h3>
                        <p>Indtast den e-mail som beregningen skal sendes til. Sæt komma mellem mailadresserne, hvis du
                          sender til flere. Vi bruger kun de indtastede mailadresser til at sende beregningen, og sletter dem herefter. Se evt. vores <a className="kammer-link" href="http://kammeradvokaten.dk/om-os/saadan-haandterer-vi-dine-personoplysninger/" target="_blank">persondatapolitik</a>.</p>
                        {!emailSend &&
                        <div className="form">
                            <div className='formFieldMulti'>
                                <input className={classNames.join(' ')}
                                    name='email'
                                    type='email'
                                    id='share-email'
                                    aria-label='Indtast en e-mailadresse'
                                    onChange={this.handleChange}
                                />
                                <label htmlFor='share-email' aria-hidden="true">E-mail*</label>
                            </div>

                            <button id="share-send" onClick={this.shareSend}>Send</button>
                        </div>
                        }
                        {submitted && !emailSend &&
                            <div className="message error">Der var en fejl i en eller flere e-mailadresser.</div>
                        }
                        {emailSend &&
                            <div className="message success">Dit resultat er nu blevet sendt.</div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ModalShareCalculation.js